import { ScopeSelectorValuesInterface } from 'domains/Marketing/components/ScopeSelector';
import {
  DiscountTypeValuesInterface,
  DiscountTypeErrorsInterface,
  LimitsValuesInterface,
  LimitsErrorsInterface,
} from './index';

export interface CouponValuesInterface
  extends DiscountTypeValuesInterface,
    LimitsValuesInterface,
    ScopeSelectorValuesInterface {
  couponCode: string;
  active: boolean;
}

export interface CouponErrorsInterface
  extends DiscountTypeErrorsInterface,
    LimitsErrorsInterface {
  couponCode: string;
}

export const CouponDateTypes = {
  LIMITED: 'limited',
  UNLIMITED: 'unlimited',
} as const;

export type CouponDateType =
  typeof CouponDateTypes[keyof typeof CouponDateTypes];

export const CouponCustomerLimitTypes = {
  LIMITED: 'limited',
  UNLIMITED: 'unlimited',
  FIRST_CONSUMER_PURCHASE: 'first_consumer_purchase',
} as const;

export type CouponCustomerLimitType =
  typeof CouponCustomerLimitTypes[keyof typeof CouponCustomerLimitTypes];
